import styled from 'styled-components';
import { Grid, Modal } from 'semantic-ui-react';

interface ImgProps {
  selected?: boolean;
}

export const InsurerImageWrapper = styled.div<ImgProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 250px;
    opacity: ${props => (props.selected ? '1' : '.3')};
    vertical-align: middle;
    border-radius: 16px;
    cursor: pointer;
  }

  ${props =>
    props.selected
      ? `
    &:after {
      content: "✅";
      position: absolute;
      bottom: -5px;
      right: -15px;
      font-size: 32px;
    }`
      : ''}
`;

export const PreQuoteWrapper = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
`;

export const PreQuoteHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px 10px 0 0;

  height: 60px;

  font-weight: bold;

  color: #fff;
  background-color: #1667fa;

  > h3 {
    color: #ffffff;
  }
`;

export const RequirementsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
`;

export const PopupContent = styled.div`
  > div {
    display: flex;
    flex-direction: column;

    > span {
    }
  }
`;

export const Subtitle = styled.h2`
  font-size: 20px;
  color: ${props => props.theme.main.color};
  padding-top: 40px;
`;

export const Hr = styled.hr`
  border: 1px solid #ddd;
`;

export const InsurerWrapper = styled.div`
  display: flex;
  font-size: 14px;
  justify-content: left;
  align-items: center;
  padding: 10px;
  gap: 0.5rem;

  input[type='checkbox'] {
    position: relative;
    cursor: pointer;
    width: 20px;
  }
  input[type='checkbox']:before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    background-color: ${props => props.theme.main.color};
  }
  input[type='checkbox']:checked:before {
    content: '';
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background-color: #fff;
    border: 1.4px solid #ccc;
    border-radius: 4px;
  }
  input[type='checkbox']:checked:after {
    content: '';
    display: block;
    width: 5px;
    height: 10px;
    border: 1px solid ${props => props.theme.main.color};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 5px;
    left: 8px;
  }
  img {
    border-radius: 50%;
    width: 30px;
    border: 1px solid #ccc;
    padding: 1px;
  }
`;

export const BudgetGridColumn = styled(Grid.Column)`
  width: unset;
  @media (max-width: 768px) {
    width: 80% !important;
  }
`;

export const BudgetPage = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  .budget-page-grid {
    width: 100%;
  }

  .budget-page-actions {
    align-items: center;
  }

  .budget-form-container {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    min-height: 100%;
    padding: 0 16px 16px;
    background: #f5f5f7;

    .budget-page-grid.ui.grid {
      width: 100% !important;
      margin: 0 !important;
    }

    .budget-page-actions {
      display: none !important;
    }

    .budget-page-grid.ui.grid > .row {
      width: 100% !important;
      margin: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .budget-page-actions > .column,
    .budget-page-selectors > .column {
      width: 100% !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .budget-page-selectors {
      padding: 0 !important;
    }

    .budget-page-selectors > .column {
      margin-bottom: 24px !important;
    }

    .budget-page-selectors .ui.dropdown,
    .budget-page-selectors .ui.selection.dropdown {
      box-sizing: border-box;
      width: 100%;
      height: 48px;
      min-height: 48px;
      padding: 0 12px;
      border: 1px solid #d8d8de;
      border-radius: 4px;
      box-shadow: none;
      display: flex;
      align-items: center;
    }

    .budget-page-selectors .ui.selection.dropdown > .text,
    .budget-page-selectors .ui.selection.dropdown > .default.text {
      color: #a9aaae;
      line-height: 20px;
    }

    .budget-page-selectors .ui.selection.dropdown > .dropdown.icon {
      margin-left: auto;
    }

    .budget-form-container .ui.grid {
      width: 100% !important;
      max-width: 100%;
      height: auto !important;
      margin: 0 !important;
    }

    .budget-form-container > .ui.grid > .column {
      width: 100% !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
      border-right: 0 !important;
      padding-left: 8px !important;
      padding-right: 8px !important;
    }

    .budget-form-container .ui.grid > .row {
      width: 100%;
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .budget-form-container .ui.grid > .row > .column {
      width: 100% !important;
      padding-left: 8px !important;
      padding-right: 8px !important;
      margin-bottom: 12px;
    }

    .budget-form-container .ui.form .field,
    .budget-form-container .ui.input,
    .budget-form-container .ui.selection.dropdown,
    .budget-form-container .ui.dropdown,
    .budget-form-container input,
    .budget-form-container textarea {
      max-width: 100%;
    }

    .budget-form-container .ui.input,
    .budget-form-container .ui.selection.dropdown,
    .budget-form-container input,
    .budget-form-container textarea {
      width: 100%;
    }

    .budget-form-container .ui.buttons,
    .budget-form-container .ui.button {
      max-width: 100%;
    }

    .budget-form-container img {
      max-width: 100%;
      height: auto;
    }

    .budget-form-container .slice-insurance-name {
      width: 100%;
      white-space: normal;
    }

    .budget-form-container .editable-coverages {
      flex-direction: column;
      align-items: stretch;
    }

    .budget-form-container .editable-coverages-input {
      width: 100%;
    }
  }
`;

export const BudgetResponsiveModal = styled(Modal)`
  @media (max-width: 767px) {
    width: calc(100% - 16px) !important;
    max-width: calc(100% - 16px) !important;
    margin: 0 auto !important;

    .content {
      max-height: calc(100vh - 150px) !important;
      overflow-x: auto !important;
    }

    .actions {
      display: flex !important;
      flex-wrap: wrap;
      gap: 8px;
    }

    .actions .button {
      flex: 1 1 140px;
      margin: 0 !important;
    }

    .pdf-page,
    canvas {
      max-width: 100%;
      height: auto !important;
    }

    table {
      min-width: 520px;
    }
  }
`;

export const MobileBudgetHeader = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    width: calc(100% + 32px);
    margin: 0 -16px;
  }
`;

export const MobileBudgetIntro = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    padding: 28px 0 12px;
  }
`;

export const MobileBudgetTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #59249b;
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;

  svg {
    color: #a9aaae;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const MobileBudgetTitleRule = styled.span`
  height: 2px;
  flex: 1;
  min-width: 24px;
  background: #a887c9;
`;

export const BudgetFieldLabel = styled.div`
  font-weight: bold;
  cursor: default;

  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 20px;
    color: #343741;
    margin-bottom: 8px;

    &:after {
      content: '*';
      color: #e53935;
      margin-left: 2px;
    }
  }
`;

export const MobileBudgetFooter = styled.div`
  display: none;

  @media (max-width: 767px) {
    position: sticky;
    bottom: 0;
    z-index: 4;
    display: flex;
    gap: 24px;
    margin: 24px -16px 0;
    padding: 16px;
    background: #f5f5f7;
  }
`;

export const MobileBudgetBackButton = styled.button`
  flex: 1;
  min-width: 0;
  height: 46px;
  border: 0;
  border-radius: 4px;
  background: #707887;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;

export const MobileBudgetNextButton = styled.button`
  flex: 1;
  min-width: 0;
  height: 46px;
  border: 0;
  border-radius: 4px;
  background: #59249b;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;
